/* eslint-disable no-console */
import AxiosClient from './api'
import END_POINT from './constants'

export function getPaymentList(payload) {
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.PAYMENT.GET}?page=${payload.page}&limit=${payload.limit}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}
